
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DelDialog from "@/views/ai-builder/components/delete-dialog.vue";
import Power, { PowerData } from "@/lib/model/power/power";
import vuexStore from "@/store/vuex-store";
import { ExamCopyForm } from "@/lib/form/exam/ExamListForm";
import ExamList from "@/lib/model/exam/exam";

import _ from "lodash";
class Department {
  no = "";
  name = "";
  // leaf = true;
  hasPermission = 0;
  children: Department[] = [];
}
@Component({
  components: { DelDialog }
})
export default class DimensionSelect extends Vue {
  @Prop({}) examId!: number;
  @Prop() examCopyForm!: ExamCopyForm;
  @Prop() examName!: string;

  show = false;
  powerData = new PowerData();
  V = vuexStore;
  status = "未开始";

  showEdit = true;
  showDel = false;
  showText = false;
  text = "";
  deleteNode: any = {}; //将确认删除的key
  dt = "";
  showTree = true;

  //树弹窗相关
  searchText = "";
  defaultProps = {
    children: "children",
    label: (data: any) => {
      return data?.name || data?.nickname;
    },
    isLeaf: "leaf"
  };
  selectedNodeKeyList = []; //默认选中节点key
  expandedNodeKeyList = ["0"]; //默认展开节点key
  userKeyList: any[] = []; //已选节点key
  departKeyList: any[] = []; //已选节点key
  userNodeList: any[] = []; //已选节点
  departNodeList: any[] = []; //已选节点
  treeData: Department[] = [new Department()];
  treeCheckedNoList: any[] = []; //总计树所有已选的no  用来处理异步加载节点之后的默认选中

  searchDepartmentList: any[] = []; //搜索结果
  searchUserList: any[] = [];

  @Watch("searchText")
  ss(n: any, o: any) {
    this.searchText = n.trim();
    if (this.searchText) {
      this.search();
      this.showTree = false;
    } else {
      this.showTree = true;
    }
  }

  async created() {
    await this.getPowerData();
    // this.getTree();
  }
  async getPowerData() {
    this.treeCheckedNoList = [];
    await Power.get({ examId: this.examId }).then(res => {
      this.powerData = res;
      //已选数据 组装
      this.departNodeList = res.departmentList;
      this.departNodeList.forEach(d => {
        this.treeCheckedNoList.push(d.no);
      });
      res.userList.forEach((d: any) => {
        d.leaf = true;
        d.no = d.userId + Math.random().toFixed(3);
        // this.treeCheckedNoList.push(d.no);
      });
      this.userNodeList = res.userList;
      this.show = true;
    });
  }
  //同步用法 已弃用
  getTree() {
    Power.tree({ examId: this.examId }).then(res => {
      this.treeData = [res];
    });
  }
  //加载节点
  loadNode(node: any, resolve?: any) {
    if (node.level === 0) {
      return resolve([{ leaf: false, name: this.V.company.name, no: "0" }]);
    }
    Power.getNode({
      examId: this.examId,
      departmentNo: node.data?.no || "0"
    }).then(res => {
      //人节点 用no伪装成部门 后续 与树交互userId遍历树后用no  与其他交互用userId判重
      res.userList.forEach((d: any) => {
        d.leaf = true;
        d.no = d.userId + Math.random().toFixed(3);
      });

      // const t = [...res.departmentTree.children, ...res.userList]; //返回树节点 部门+人员
      const t = [...res.departmentTree.children]; //返回树节点 部门
      setTimeout(() => {
        resolve(t);
        this.$nextTick(() => {
          //处理已选
          const all = (this.$refs.tree as any).store._getAllNodes();
          //找到已选的人 选中
          this.userNodeList.forEach((d: any) => {
            all.forEach((n: any) => {
              if (n.data?.userId && d.userId == n.data?.userId) {
                this.checkNode(n.data, true);
                // (this.$refs.tree as any).setChecked(n.no, true, false);
                //没有则加入总计
                if (
                  !this.treeCheckedNoList.find(h => {
                    return h === n.data?.no;
                  })
                ) {
                  this.treeCheckedNoList.push(n.data?.no);
                }
              }
            });
          });
          //选中已选 自动触发checkNode方法
          (this.$refs.tree as any)?.setCheckedKeys(this.treeCheckedNoList);
        });
      }, 250);
    });
  }
  //树节点操作 唯一入口
  checkNode(node: any, checked: boolean, e?: any) {
    if (node.userId) {
      //人节点
      if (checked) {
        this.treeCheckedNoList.push(node.no);
        //重复的人
        const aa = (this.$refs.tree as any).store._getAllNodes();
        aa.forEach((d: any) => {
          if (d.data.userId && d.data.userId == node.userId) {
            (this.$refs.tree as any).setChecked(d.data.no, true, false);
          }
        });
        if (
          //未重复的人
          !this.userNodeList.find(d => {
            return d.userId === node.userId;
          })
        ) {
          this.userNodeList.push(node);
        }
      } else {
        this.delUser(node);
      }
    } else {
      //部门节点
      if (checked) {
        if (
          //未重复的部门
          !this.departNodeList.find(d => {
            return d.no === node.no;
          })
        ) {
          this.treeCheckedNoList.push(node.no);
          this.departNodeList.push(node);
          (this.$refs.tree as any).setChecked(node.no, true, false);
        }
      } else {
        this.delDepart(node);
      }
    }
  }
  //删部门
  delDepart(node: any) {
    //删已选
    const i = this.departNodeList.findIndex((d: any) => {
      return d.no == node.no;
    });
    if (i !== -1) {
      this.departNodeList.splice(i, 1);
    }
    //删总计
    const ii = this.treeCheckedNoList.findIndex((d: any) => {
      return d == node.no;
    });
    if (ii !== -1) {
      this.treeCheckedNoList.splice(ii, 1);
    }
    //设置树节点
    (this.$refs.tree as any).setChecked(node.no, false, false);
    //设置搜索结果
    this.searchDepartmentList.forEach((s: any) => {
      if (s.no == node.no) {
        s.checked = false;
      }
    });
  }
  //删人
  delUser(node: any) {
    //删已选
    const i = this.userNodeList.findIndex((d: any) => {
      return d.userId == node.userId;
    });
    if (i !== -1) {
      this.userNodeList.splice(i, 1);
    }
    //删总计
    const ii = this.treeCheckedNoList.findIndex((d: any) => {
      return d == node.no;
    });
    if (ii !== -1) {
      this.treeCheckedNoList.splice(ii, 1);
    }
    //设置搜索结果
    this.searchUserList.forEach((s: any) => {
      if (s.userId == node.userId) {
        s.checked = false;
      }
    });
    //重复的人
    const aa = (this.$refs.tree as any).getCheckedNodes();
    aa.forEach((d: any) => {
      if (d.userId && d.userId == node.userId) {
        (this.$refs.tree as any).setChecked(d.no, false, false); //设置树节点
        //总计里找到 删
        const iii = this.treeCheckedNoList.findIndex(m => {
          return m == d.no;
        });
        if (iii !== -1) {
          this.treeCheckedNoList.splice(iii, 1);
        }
      }
    });
  }
  //已选里删除
  delNode(node: any) {
    this.checkNode(node, false);
  }
  ////////树操作相关 over////

  ///搜索相关///
  search() {
    Power.search({ examId: this.examId, searchKey: this.searchText }).then(
      res => {
        //结果是否选中
        res.departmentList.forEach((d: any) => {
          d.checked = this.departNodeList.some((n: any) => {
            return d.no === n.no;
          });
        });
        res.userList.forEach((d: any) => {
          d.checked = this.userNodeList.some((n: any) => {
            return d.userId === n.userId;
          });
        });
        this.searchDepartmentList = res.departmentList;
        this.searchUserList = res.userList;
      }
    );
  }
  //复选框
  setRes(node: any, checked: any) {
    this.checkNode(node, checked);
  }
  successList: any[] = [];
  failList: any[] = [];
  async editOk() {
    //
    this.status = "正在批量复制中。。。";
    const departList = (this.$refs.tree as any)?.getCheckedNodes();
    for (let i = 0; i < departList.length; i++) {
      //
      this.examCopyForm.departmentNo = departList[i].no;
      this.examCopyForm.name = this.examName + "-" + departList[i].name;
      await this.copyExam(this.examCopyForm).then(res => {
        //
      });
    }
    if (departList.length === this.successList.length + this.failList.length) {
      this.status = "全部完成，请关闭弹窗，刷新页面查看";
    } else {
      this.status = "网络异常，稍后再试";
    }
  }
  async copyExam(p: any) {
    await ExamList.examCopy(p)
      .then(res => {
        if (res.code === 0) {
          this.successList.push(p.name);
        } else {
          this.failList.push(p.name);
        }
        return Promise.resolve(res);
      })
      .catch(e => {
        this.status = "网络异常，稍后再试";
        return Promise.reject(e);
      });
  }
  //删除弹窗
  toDelete(d: any) {
    if (d?.nickname) {
      this.dt = "确认删除该用户的操作权限？";
    } else {
      this.dt = "确认删除" + d.name + "及下级部门的操作权限？";
    }
    this.showDel = true;
    this.deleteNode = d;
  }
  del() {
    if (this.deleteNode.userId) {
      //删人
      const i = this.userNodeList.findIndex((d: any) => {
        return d.userId === this.deleteNode.userId;
      });
      if (i !== -1) {
        this.userNodeList.splice(i, 1);
      }
    } else {
      //删部门
      const i = this.departNodeList.findIndex((d: any) => {
        return d.no === this.deleteNode.no;
      });
      if (i !== -1) {
        this.departNodeList.splice(i, 1);
      }
    }
    this.$message.success("删除成功");
    this.showDel = false;
  }
  //关闭
  close() {
    this.$emit("close", false);
  }
}
